import useInView from "../hooks/useInView";

// Uses Tailwind's built-in motion-safe: variant so users who have
// "prefers-reduced-motion: reduce" set in their OS see content
// immediately — no hidden-until-scrolled, no animation.
export default function Reveal({ children, className = "", delay = 0 }) {
  const [ref, inView] = useInView();

  return (
    <div
      ref={ref}
      className={`${className} motion-safe:will-change-transform ${
        inView
          ? "motion-safe:animate-fade-in-up"
          : "motion-safe:opacity-0 motion-safe:translate-y-5"
      }`}
      style={{ animationDelay: delay ? `${delay}ms` : undefined }}
    >
      {children}
    </div>
  );
}
